import { Discourage, Hint } from "../../../../source/components/hint";
import * as React from 'react';
export default {
  Discourage,
  Hint,
  React
};